import { Box } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

export const Hints = () => {
  return (
    <Box paddingTop="s24">
      <Callout
        type="info"
        title={i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.login.callout.title'
        )}
        description={i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.login.callout.content'
        )}
      />
    </Box>
  )
}
